/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Svchip_ComplianceInputs */

const en_svchip_compliance = /** @type {(inputs: Svchip_ComplianceInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Compliance`)
};

const ar_svchip_compliance = /** @type {(inputs: Svchip_ComplianceInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`الامتثال`)
};

const bn_svchip_compliance = /** @type {(inputs: Svchip_ComplianceInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`কমপ্লায়েন্স`)
};

const de_svchip_compliance = /** @type {(inputs: Svchip_ComplianceInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Compliance`)
};

const es_svchip_compliance = /** @type {(inputs: Svchip_ComplianceInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Cumplimiento`)
};

const fr_svchip_compliance = /** @type {(inputs: Svchip_ComplianceInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Conformité`)
};

const pt_svchip_compliance = /** @type {(inputs: Svchip_ComplianceInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Conformidade`)
};

const zh_svchip_compliance = /** @type {(inputs: Svchip_ComplianceInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`合规性`)
};

const tr_svchip_compliance = /** @type {(inputs: Svchip_ComplianceInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Uyumluluk`)
};

const ru_svchip_compliance = /** @type {(inputs: Svchip_ComplianceInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Соответствие`)
};

const pl_svchip_compliance = /** @type {(inputs: Svchip_ComplianceInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Zgodność`)
};

/**
* | output |
* | --- |
* | "Compliance" |
*
* @param {Svchip_ComplianceInputs} inputs
* @param {{ locale?: "en" | "ar" | "bn" | "de" | "es" | "fr" | "pt" | "zh" | "tr" | "ru" | "pl" }} options
* @returns {LocalizedString}
*/
export const svchip_compliance = /** @type {((inputs?: Svchip_ComplianceInputs, options?: { locale?: "en" | "ar" | "bn" | "de" | "es" | "fr" | "pt" | "zh" | "tr" | "ru" | "pl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Svchip_ComplianceInputs, { locale?: "en" | "ar" | "bn" | "de" | "es" | "fr" | "pt" | "zh" | "tr" | "ru" | "pl" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "ar") return ar_svchip_compliance(inputs)
	if (locale === "bn") return bn_svchip_compliance(inputs)
	if (locale === "de") return de_svchip_compliance(inputs)
	if (locale === "es") return es_svchip_compliance(inputs)
	if (locale === "fr") return fr_svchip_compliance(inputs)
	if (locale === "pt") return pt_svchip_compliance(inputs)
	if (locale === "zh") return zh_svchip_compliance(inputs)
	if (locale === "tr") return tr_svchip_compliance(inputs)
	if (locale === "ru") return ru_svchip_compliance(inputs)
	if (locale === "pl") return pl_svchip_compliance(inputs)
	return en_svchip_compliance(inputs)
});